import Icon from '../../common/icons/Icon.js'
import {panelLinkSelector} from './analyticsSelectors.js'
import {useSelector} from '../../store.js'
import className from '../../common/className.js'

/**
 * Side nav link
 *
 * @param {Object} props
 * @param {String} props.title
 * @param {String} props.name
 * @param {String} props.icon
 * @param {Boolean} props.isActive
 * @returns {React.ReactNode}
 */
export default function SideNavLink({title, name, icon, isActive}) {
  const href = useSelector((state) => panelLinkSelector(state, {panel: name}))

  return (
    <li
      className={className`side-nav__item ${{
        'side-nav__item--active': isActive,
      }}`}
    >
      <a className="side-nav__link" title={title} href={href}>
        <Icon name={icon} className="icon-svg fs-02 margin-right-5" />{' '}
        <span>{title}</span>
      </a>
    </li>
  )
}
